import { Flex } from "antd";
import { colors } from "shared/theme/color";
import { textPx } from "shared/constants/zoom";

// Numbered eyebrow header for a create-panel section (e.g. "1 · Kelas").
export const SectionEyebrow = ({
  num,
  label,
}: {
  num: number;
  label: string;
}) => (
  <Flex align="center" gap={8} style={{ marginBottom: 14 }}>
    <span
      style={{
        width: 18,
        height: 18,
        borderRadius: 999,
        background: colors.bgSoft,
        color: colors.ink2,
        fontSize: textPx(10),
        fontWeight: 600,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
      }}
    >
      {num}
    </span>
    <span
      style={{
        fontSize: textPx(11),
        fontWeight: 600,
        textTransform: "uppercase",
        letterSpacing: "0.08em",
        color: colors.ink3,
      }}
    >
      {label}
    </span>
  </Flex>
);
